export const isDevelopmentEnvironment = (): boolean => import.meta.env.VITE_ENVIRONMENT === "development";
